import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetogoathreedayspackages() {



const cardData =
{
  keyword: 'Pune to Goa 3 Days Package',

  heading: 'Lotus Cab: Pune to Goa 3 Days Package ',

headingDescription:
  "Lotus Cabs offers a well-planned Pune to Goa 3 Days Package for families, couples, friends, and corporate groups looking for a comfortable and memorable Goa holiday. Our three-day tour packages provide convenient cab travel, flexible sightseeing options, and a stress-free travel experience from Pune to Goa and throughout your trip. Choose from our premium fleet of Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus, all driven by professional and experienced chauffeurs. With 24x7 booking support, transparent pricing, doorstep pickup from any location in Pune, well-maintained vehicles, and safe highway travel, Lotus Cabs ensures a smooth, enjoyable, and hassle-free Pune to Goa 3 Days Package journey.",



  top: 'Top Places to Visit in Goa before Traveling to Pune with Lotus Cab',

topPlaces: [
   
   
     {
        title: "Grand Island",
        description:
            "Grand Island is one of Goa's most popular adventure destinations, famous for snorkeling, scuba diving, fishing, and exploring vibrant marine life. Surrounded by crystal-clear waters of the Arabian Sea, the island offers an exciting experience for adventure seekers and nature lovers."
    },
    {
        title: "Cotigao Wildlife Sanctuary",
        description:
            "Cotigao Wildlife Sanctuary is one of Goa's oldest wildlife reserves, known for dense forests, diverse wildlife, and beautiful natural landscapes. Visitors can explore walking trails, spot animals and birds, and enjoy the peaceful environment away from crowded tourist areas."
    },
     {
        title: "Kakolem Beach",
        description:
            "Kakolem Beach, also known as Tiger Beach, is a secluded coastal paradise surrounded by cliffs and greenery. Its untouched beauty, peaceful atmosphere, and scenic views make it one of Goa's best offbeat beach destinations."
    },
    {
        title: "Betul Beach",
        description:
            "Betul Beach is a quiet fishing village beach in South Goa known for its serene coastline, traditional seafood, and beautiful sunset views. The peaceful surroundings make it perfect for travelers looking to experience authentic Goan culture."
    },
    {
        title: "Netravali Wildlife Sanctuary",
        description:
            "Netravali Wildlife Sanctuary is a hidden gem in South Goa, famous for lush green forests, waterfalls, trekking routes, and rich biodiversity. The sanctuary offers a refreshing experience for travelers interested in nature, photography, and wildlife exploration."
    },
    {
        title: "Cabo de Rama Fort",
        description:
            "Cabo de Rama Fort is a historic fort located on a cliff overlooking the Arabian Sea. Famous for its spectacular ocean views, ancient architecture, and peaceful surroundings, it is an excellent destination for history lovers and sunset photography."
    },
    {
        title: "Salaulim Dam",
        description:
            "Salaulim Dam is a scenic attraction surrounded by lush greenery and natural landscapes. The unique spillway design, peaceful reservoir, and beautiful gardens make it a relaxing destination for families and nature enthusiasts."
    },
    {
        title: "Hollant Beach",
        description:
            "Hollant Beach is a calm and less crowded beach near Vasco da Gama, known for its shallow waters, peaceful environment, and stunning sunrise views. It is an ideal spot for swimming, photography, and enjoying a relaxing coastal experience."
    },
    {
        title: "Kesarval Spring",
        description:
            "Kesarval Spring is a natural spring near Cortalim known for its scenic surroundings and traditional importance. Surrounded by greenery, the location offers visitors a peaceful escape and a chance to explore Goa's natural attractions."
    },
    {
        title: "Palácio do Deão",
        description:
            "Palácio do Deão is a historic Portuguese-style heritage mansion located in Quepem, Goa. Known for its beautiful architecture, riverside gardens, and cultural significance, the palace offers visitors a glimpse into Goa's colonial-era lifestyle and traditions."
    }
],





"services": [
  {
    "name": "Pune to Goa 3 Days Package",
    "description": "Book Pune to Goa 3 days package for a relaxing and memorable beach vacation with comfortable cab transportation and flexible travel plans. This package is perfect for families, couples, and groups looking to explore Goa at a leisurely pace. Enjoy private transportation, spacious vehicles, and enough time to visit famous beaches, forts, churches, markets, and popular tourist attractions during your three-day getaway."
  },
  {
    "name": "Pune to Goa 3 Days Tour Package",
    "description": "Pune to Goa 3 days tour package offers a complete holiday experience with convenient transportation and customized sightseeing itineraries. Travelers can enjoy comfortable AC vehicles, professional drivers, and ample time to discover North Goa and South Goa attractions. The package is ideal for family vacations, honeymoon trips, and weekend holidays."
  },
  {
    "name": "Pune to Goa 3 Days Cab Package",
    "description": "Book Pune to Goa 3 days cab package and enjoy the flexibility of private transportation for your entire trip. Choose from sedan, Ertiga, Innova Crysta, and SUV options according to your travel requirements. The package includes comfortable travel, sightseeing opportunities, and personalized schedules for a stress-free holiday."
  },
  {
    "name": "Pune to Goa Holiday Package 3 Days",
    "description": "Pune to Goa holiday package 3 days is specially designed for travelers who want to enjoy a relaxing vacation without rushing through attractions. Explore beaches, water sports activities, local markets, and historical sites while traveling in comfortable vehicles with experienced chauffeurs and flexible itineraries."
  },
  {
    "name": "Pune to Goa Family Package 3 Days",
    "description": "Pune to Goa family package 3 days is ideal for families looking to spend quality time together on a beach vacation. Spacious vehicles, convenient pickup and drop services, and customized sightseeing plans ensure a comfortable and enjoyable experience for children, adults, and senior citizens."
  },
  {
    "name": "Pune to Goa Taxi Package 3 Days",
    "description": "Book Pune to Goa taxi package 3 days and enjoy private cab transportation with experienced drivers and well-maintained AC vehicles. This package provides flexible travel schedules and enough time to explore Goa's scenic beauty and major attractions comfortably."
  },
  {
    "name": "Goa 3 Days Package from Pune",
    "description": "Goa 3 days package from Pune offers a complete travel solution for tourists seeking a relaxing and memorable holiday. The package includes private transportation, comfortable vehicles, and personalized itineraries to help travelers explore beaches, churches, forts, and local attractions with ease."
  },
  {
    "name": "Pune to Goa Sightseeing Package 3 Days",
    "description": "Pune to Goa sightseeing package 3 days includes comfortable cab services and visits to popular destinations across North and South Goa. Travelers can enjoy a personalized tour experience with flexible schedules, professional drivers, and sufficient time to explore famous tourist attractions and beaches."
  },
  {
    "name": "Pune to Goa Tour by Cab 3 Days",
    "description": "Book Pune to Goa tour by cab 3 days and experience the convenience of private transportation with customized sightseeing and travel plans. Comfortable vehicles and experienced chauffeurs ensure a smooth and enjoyable journey, making the package perfect for families, couples, and small groups."
  },
  {
    "name": "Pune to Goa Vacation Package",
    "description": "Pune to Goa vacation package is designed for travelers looking for a complete and relaxing holiday experience with private cab transportation and flexible itineraries. Enjoy comfortable travel, explore Goa's beautiful beaches and tourist attractions, and create unforgettable memories with your family and friends during your vacation."
  }
],

"tableData": [
  ["Pune to Goa 3 Days Package", "Pune to Goa 3 Days Tour Package"],
  ["Pune to Goa 3 Days Cab Package", "Pune to Goa Holiday Package 3 Days"],
  ["Pune to Goa Family Package 3 Days", "Pune to Goa Taxi Package 3 Days"],
  ["Goa 3 Days Package from Pune", "Pune to Goa Sightseeing Package 3 Days"],
  ["Pune to Goa Tour by Cab 3 Days", "Pune to Goa Vacation Package"]
],






"whychoose": [
  {
    "WhyChooseheading": "Ideal Long Weekend Getaway",
    "WhyChoosedescription": "Enjoy a relaxing 3-day Goa vacation from Pune with a comfortable and well-planned travel package."
  },
  {
    "WhyChooseheading": "Customizable Travel Schedule",
    "WhyChoosedescription": "Plan your trip according to your preferred beaches, sightseeing spots, and stay duration."
  },
  {
    "WhyChooseheading": "Comfortable Vehicle Choices",
    "WhyChoosedescription": "Choose from Sedan, Ertiga, Innova Crysta, and SUVs for a pleasant family or group journey."
  },
  {
    "WhyChooseheading": "Affordable Tour Packages",
    "WhyChoosedescription": "Budget-friendly package options designed for couples, families, and friends."
  },
  {
    "WhyChooseheading": "Pickup from Anywhere in Pune",
    "WhyChoosedescription": "Convenient pickup services from homes, hotels, offices, airports, and railway stations."
  },
  {
    "WhyChooseheading": "Professional Chauffeur Service",
    "WhyChoosedescription": "Experienced drivers ensure a safe and enjoyable journey to and from Goa."
  },
  {
    "WhyChooseheading": "Perfect for Family Vacations",
    "WhyChoosedescription": "Spend quality time with loved ones through a comfortable and hassle-free Goa trip."
  },
  {
    "WhyChooseheading": "24/7 Booking Assistance",
    "WhyChoosedescription": "Our support team is available anytime to help with package details and reservations."
  }
]
};

const faqData = [
  {
    question: 'Does Lotus Cab provide a Pune to Goa 3 Days Package?',
    answer: 'Yes, Lotus Cab offers customized 3-day Goa packages from Pune for couples, families, and group travelers.'
  },
  {
    question: 'What is included in the Pune to Goa 3 Days Package?',
    answer: 'The package includes a comfortable cab with a professional driver and flexible travel options that can be customized according to your itinerary.'
  },
  {
    question: 'What is the distance from Pune to Goa?',
    answer: 'The road distance between Pune and Goa is approximately 450 km, and the journey generally takes around 8 to 10 hours.'
  },
  {
    question: 'Which vehicles are available for the 3-day package?',
    answer: 'We provide Sedan cars, Ertiga, Innova Crysta, and SUVs depending on the number of passengers and luggage requirements.'
  },
  {
    question: 'Can I customize my Goa sightseeing plan?',
    answer: 'Yes, the package can be personalized according to your preferred beaches, tourist attractions, and travel schedule.'
  },
  {
    question: 'Do you offer pickup from Pune Airport and railway station?',
    answer: 'Yes, Lotus Cab provides pickup services from Pune Airport, railway stations, hotels, and residential locations.'
  },
  {
    question: 'Are toll and parking charges included in the package?',
    answer: 'Toll charges, parking fees, and state taxes are generally charged separately unless specifically included in the package quotation.'
  },
  {
    question: 'Is the package suitable for family vacations and friends trips?',
    answer: 'Absolutely. The 3-day Goa package is perfect for families, couples, and groups looking for an extended holiday.'
  },
  {
    question: 'Can I extend my stay in Goa beyond three days?',
    answer: 'Yes, we offer flexible options to extend your trip and customize the package according to your requirements.'
  },
  {
    question: 'How can I book a Pune to Goa 3 Days Package with Lotus Cab?',
    answer: 'Simply share your travel date, pickup location, number of passengers, and preferred vehicle to receive package details and booking confirmation.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sanket Joshi',
    feedback: 'Three days in Goa gave us enough time to explore beaches and relax with family. Lotus Cab handled the transportation perfectly and made the trip stress-free.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Deepali Kulkarni',
    feedback: 'Our group wanted a longer Goa vacation, and this package suited us perfectly. The cab was comfortable, and every part of the journey was well organized.',
    rating: 5,
  },
];








































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];






const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Goa 3 Days Package",
"image": "https://lotuscab.com/assets/images/pune-to-goa-3-days-package.jpg",
"description": "Book Pune to Goa 3 Days Package with Lotus Cab for a relaxing and memorable holiday tour. Enjoy family vacation packages, sightseeing tours, and private cab packages from Pune to Goa with comfortable AC taxis, experienced drivers, and 24x7 service.",
"brand": {
"@type": "Brand",
"name": "Lotus Cab"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "7215"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹18/Km",
"availability": "https://schema.org/InStock",
"url": "https://lotuscab.com/pune-to-goa-3-days-package"
}
};








  return (
    <div>
      
<Helmet>
  <title>Pune to Goa 3 Days Package | Family Tour by Cab | +91 8767592195</title>

<meta
 name="description"
 content="Book Pune to Goa 3 Days Package with Lotus Cab for affordable family holidays and sightseeing tours. Get private cab packages, taxi packages, and Goa tour by cab with professional drivers and comfortable vehicles."
/>

<meta
 name="keywords"
 content="Pune to Goa 3 Days Package, Pune to Goa 3 Days Tour Package, Pune to Goa 3 Days Cab Package, Pune to Goa Holiday Package 3 Days, Pune to Goa Family Package 3 Days, Pune to Goa Taxi Package 3 Days, Goa 3 Days Package from Pune, Pune to Goa Sightseeing Package 3 Days, Pune to Goa Tour by Cab"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>








 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/105.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetogoathreedayspackages;